import React from 'react';
import Img from 'gatsby-image/withIEPolyfill';
import PropTypes from 'prop-types';

export const renderPossiblyOptimizedImage = (
  { src, ...props },
  optimizedImages
) => {
  if (Array.isArray(optimizedImages)) {
    const imageIndex = optimizedImages.findIndex(i => i.node.url === src);
    const optimizedImage = imageIndex > -1 ? optimizedImages[imageIndex] : null;

    if (
      optimizedImage &&
      optimizedImage.node &&
      optimizedImage.node.childImageSharp &&
      optimizedImage.node.childImageSharp.fluid
    ) {
      const { fluid } = optimizedImage.node.childImageSharp;

      return (
        <div className="img-wrapper">
          <Img
            fluid={fluid}
            style={{
              ...((fluid.presentationWidth < 970 || fluid.aspectRatio < 1) && {
                maxWidth: fluid.presentationWidth
              }),
              ...(fluid.aspectRatio < 1 && {
                maxHeight: 800 // [Style] Tweak max-height for portrait images
              })
            }}
            {...props}
          />
        </div>
      );
    }
  }

  return <img src={src} {...props} />;
};

renderPossiblyOptimizedImage.propTypes = {
  src: PropTypes.string
};
